<div class="container-fluid page" *ngIf="!editNews">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp; News Updates
    <div class="export_csv" style="margin-bottom: 5px !important">
      <div class="add_button_text">
        <button
          class="add_button_new pull-right"
          mat-raised-button
          (click)="formPage()"
          style="color: #295fc2"
        >
          Share a News Update
        </button>
      </div>
      &nbsp;&nbsp;<button
        class="clear_button_export"
        style="float: right; margin-top: -36px"
        mat-raised-button
        color="primary"
        (click)="openDialogexport()"
      >
        Export
      </button>
    </div>
  </div>

  <div class="page__content shadow p-3">
    <div>
      <br />
      <div>
        <table class="firstTable">
          <tr>
            <th class="FirstTh">Total News Articles Published</th>
            <th class="FirstTh">Published This Month</th>
            <th class="FirstTh"></th>
          </tr>
          <tr style="height: 50px">
            <td class="FirstTd">{{ getAverageData.totalNews }}</td>
            <td class="FirstTd">{{ getAverageData.totalMonthNews }}</td>
            <!-- <td class="FirstTd">{{getAverageData.averageReviewRating}}</td> -->
          </tr>
        </table>
      </div>

      <mat-card>
        <div class="example-header" *ngIf="filtershow">
          <mat-form-field
            class="full-width-field"
            style="width: 50% !important"
          >
            <input
              matInput
              [(ngModel)]="searchData"
              (change)="changeFn($event)"
              placeholder="Search"
            /> </mat-form-field
          >&nbsp;
          <button
            type="submit"
            (click)="applyfilter(true)"
            class="btn btn-primary mat-primary search_bar"
          >
            <mat-icon class="search_bar_icon">search</mat-icon>
          </button>
          <hr />

          <mat-form-field>
            <mat-label>Language</mat-label>
            <mat-select [(ngModel)]="languageName">
              <mat-option
                *ngFor="let language of languageList"
                [value]="language.value"
              >
                {{ language.viewValue }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;

          <!-- <mat-form-field>
                        <mat-label>Date Shared</mat-label>
                        <mat-select [(ngModel)]="sharedate" (selectionChange)="selectItem($event)">
                            <mat-option *ngFor="let x of datepicker" [value]="x.viewValue" (click)="getDate(x)">
                                {{x.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>&nbsp; -->

          <!-- <input type="text" ngxDaterangepickerMd startKey="start" endKey="end" [isCustomDate]='true'
                        [showCustomRangeLabel]="true" [locale]="{applyLabel: 'ok', customRangeLabel: 'Custom range'}"
                         [linkedCalendars]="true" [ranges]="ranges" [(ngModel)]="model"> -->

          <!-- <div class="container"> -->
          <!-- <div class="row">
                            <div class="col-sm-3"> -->
          <!-- <form>
                                    <div class="form-group"> -->
          <mat-form-field>
            <!-- <label for="exampleInputEmail1">The range date</label> -->
            <input
              matInput
              type="text"
              name="daterange"
              placeholder="Date Range"
              [min]="minDate"
              autocomplete="off"
              [max]="maxDate"
              [alwaysShowCalendars]="true"
              ngxDaterangepickerMd
              [(ngModel)]="sharedate"
              [showCustomRangeLabel]="true"
              [ranges]="ranges"
              (change)="onDateRangeChanged(sharedate)"
            />
          </mat-form-field>
          <!-- </div>
                                </form> -->
          <!-- </div>
                        </div> -->
          <!-- </div> -->

          <!-- <form>
                        <div class="form-group">
                            <label for="exampleInputEmail1">The range date</label>
                            <input type="text" name="daterange" ngxDaterangepickerMd [(ngModel)]="selected" class="form-control" 
                            startKey="start" endKey="end" [isCustomDate]='true'  
                    [locale]="{applyLabel: 'ok', customRangeLabel: 'Custom range'}" [linkedCalendars]="true" [ranges]="ranges" />
                        </div>
                    </form> -->

          <!-- <mat-form-field *ngIf="customDate">
                        <mat-label>Custom Date</mat-label>
                        <mat-date-range-input [formGroup]="form" [rangePicker]="picker">
                            <input [(ngModel)]="formdate" matStartDate formControlName="start" placeholder="Start date">
                            <input [(ngModel)]="todayte" matEndDate formControlName="end" placeholder="End date">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field> -->

          <button
            class="btn btn-primary mat-primary clear_button pull-right"
            style="margin-top: 12px"
            (click)="clearFilter()"
          >
            Clear Filter
          </button>
          <button
            type="submit"
            style="margin-top: 12px; margin-right: 10px"
            (click)="applyfilter(true)"
            class="btn btn-primary mat-primary pull-right"
          >
            Apply Filter
          </button>

          <mat-chip-list #chipList aria-label="Filter selection">
            <mat-chip
              *ngFor="let filter of matChipArray; let i = index"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(i, filter.tag)"
            >
              {{ filter.name }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
          <div class="text_filter_data" *ngIf="exportcsvdata">
            <p *ngIf="this.length == 0">
              There's no record found with the given criteria, please try again
              refining your search and filters
            </p>
          </div>
        </div>
      </mat-card>

      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Headline
            </mat-header-cell>
            <mat-cell *matCellDef="let newData" class="userNameCol">
              <span style="width: 220px"> {{ newData.title }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="thumbnail">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Thumbnail
            </mat-header-cell>
            <mat-cell *matCellDef="let newData">
              <!-- {{ newData.image }} -->
              <img [src]="newData.image" style="width: 50px; height: 50px" />
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="source">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Source
            </mat-header-cell>
            <mat-cell *matCellDef="let newData" class="userNameCol">
              <span style="width: 130px">{{ newData.source }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="languages">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Language
            </mat-header-cell>
            <mat-cell *matCellDef="let newData">
              {{ getLanguages(newData.languages) }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="publishDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Date
            </mat-header-cell>
            <mat-cell *matCellDef="let newData">
              {{ newData.publishDate.split(" ")[0] }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="updatedBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Updated By
            </mat-header-cell>
            <mat-cell *matCellDef="let newData">
              {{ newData.updatedBy }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Action
            </mat-header-cell>
            <mat-cell *matCellDef="let newData">
              <div>
                <mat-icon (click)="editPage(newData)">edit</mat-icon
                >&nbsp;&nbsp;
                <mat-icon (click)="openDialog(newData)">delete</mat-icon>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <div>
          <mat-paginator
            [length]="length"
            [pageIndex]="pageIndex"
            (page)="getServerData($event)"
            [pageSizeOptions]="[10, 20, 50]"
            showFirstLastButtons
            aria-label=""
            class="pagination"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<!---==============================edit data html =================================================-->
<div class="container-fluid page" *ngIf="editNews">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="listPage()"
    />&nbsp;&nbsp;Edit a Updated News
  </div>
  <div class="example-header" style="height: 557px">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="newsform" (ngSubmit)="onSubmit()">
          <div class="fulllwidth">
            <input type="hidden" formControlName="newsId" value="" />

            <mat-form-field>
              <input
                type="text"
                formControlName="newsTitle"
                required
                matInput
                placeholder="Headline"
              />
            </mat-form-field>

            <mat-form-field>
              <input
                type="text"
                formControlName="newsSource"
                required
                matInput
                placeholder="Source"
              />
            </mat-form-field>

            <div>
              <span>
                <mat-form-field appearance="fill" style="width: 48% !important">
                  <mat-label>Choose a date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="date"
                    [max]="getToday()"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field> </span
              >&nbsp;&nbsp;
              <span>
                <mat-form-field appearance="fill" style="width: 48% !important">
                  <mat-label>Language</mat-label>
                  <mat-select formControlName="languages" multiple>
                    <mat-option
                      *ngFor="let language of languageList"
                      [value]="language.value"
                    >
                      {{ language.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
            </div>

            <mat-form-field>
              <input
                type="text"
                formControlName="attachlink"
                id="attachlink"
                required
                matInput
                placeholder="Link"
              />
            </mat-form-field>

            <!-- <mat-form-field>
                            <input type="text"  maxlength="100" rows="2" required
                                formControlName="remark" matInput placeholder="Remark">
                        </mat-form-field> -->

            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <button
                  mat-button
                  type="submit"
                  [disable]="disable"
                  style="color: white"
                  class="submitBtn pull-right"
                >
                  Share
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
